import { useState } from "react";
import IconMenu from "../IconMenu/IconMenu";
import styles from "./Navbar.module.css";
import Logo from "../Logo/Logo";
import DownloadButton from "../Button/DownloadButton";
import { Link } from "react-router-dom";
function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <>
      <div className={styles.headerDesktop}>
        <IconMenu />
        <header className={styles.header}>
          <nav className={styles.navigation}>
            <Logo />
            <div className={styles.toggleButton} onClick={handleMenuToggle}>
              <span className={styles.bar}></span>
              <span className={styles.bar}></span>
              <span className={styles.bar}></span>
            </div>
            <ul className={styles.NavBarList}>
              <li>
                <Link to="/#welcome">Welcome</Link>
              </li>
              <li>
                <a href="#services">What I Do</a>
              </li>
              <li>
                <a href="#about">About Me</a>
              </li>
              <li>
                <a href="#testimonials">Testimonials</a>
              </li>
              <li>
                <a href="#portfolio">Portfolio</a>
              </li>
              <li>
                <a href="#contact">Contact Me</a>
              </li>
              <li>
                <a
                  href="http://blog.akanbijr.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>
              </li>
            </ul>
          </nav>
          <div className={styles.button}>
            <DownloadButton className={styles.button}>
              Download CV
            </DownloadButton>
          </div>
        </header>
      </div>

      <div className={styles.mobileMenu}>
        <IconMenu />
        <header className={styles.headerMobile}>
          <nav className={styles.navigation}>
            <Logo />
            <div className={styles.toggleButton} onClick={handleMenuToggle}>
              <span className={styles.bar}></span>
              <span className={styles.bar}></span>
              <span className={styles.bar}></span>
            </div>
            <ul
              className={menuOpen ? styles.NavBarListMenu : styles.NavBarList}
            >
              <li>
                <a href="#welcome">Welcome</a>
              </li>
              <li>
                <a href="#services">What I Do</a>
              </li>
              <li>
                <a href="#about">About Me</a>
              </li>
              <li>
                <a href="#testimonials">Testimonials</a>
              </li>
              <li>
                <a href="#portfolio">Portfolio</a>
              </li>
              <li>
                <a href="#contact">Contact Me</a>
              </li>
              <li>
                <a
                  href="http://blog.akanbijr.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>
              </li>
            </ul>
          </nav>
        </header>
      </div>
    </>
  );
}

export default Navbar;
